import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSmartwatch1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSmartwatch1"><Path d="M12 8.5V12L13.75 13.75M4.5 4.5H19.5V19.5H4.5V4.5ZM7 4.5L8 1.5H16L17 4.5H7ZM7 19.5L8 22.5H16L17 19.5H7Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSmartwatch1;
